import React, {useEffect, useState} from 'react';
import {Freeze} from 'react-freeze';
import {StyledVideoList, getLeft, useTheme} from '@100mslive/roomkit-react';
import {useVideoList} from '@100mslive/react-sdk';
import VideoTile from './VideoTile';
import ScreenshareTile from './ScreenshareTile';
import {Pagination} from './Pagination';

import {useAppConfig} from '../AppData/useAppConfig';
import {useIsHeadless} from '../AppData/useUISettings';
import {FeatureFlags} from '../../services/100-ms-services/FeatureFlags';

const List = ({
  maxTileCount,
  peers,
  showStatsOnTiles,
  maxColCount,
  maxRowCount,
  includeScreenShareForPeer,
}: any) => {
  const {aspectRatio} = useTheme();
  const appConfig = useAppConfig();
  const isHeadless = useIsHeadless();
  const {ref, pagesWithTiles} = useVideoList({
    peers,
    maxTileCount,
    maxColCount,
    maxRowCount,
    includeScreenShareForPeer,
    aspectRatio,
    offsetY: getOffset({isHeadless, appConfig}),
  });
  const [page, setPage] = useState(0);
  useEffect(() => {
    // currentPageIndex should not exceed pages length
    if (page >= pagesWithTiles.length) {
      setPage(0);
    }
  }, [pagesWithTiles.length, page]);
  const useFreeze = FeatureFlags.freezeVideoList();
  console.log(pagesWithTiles);
  return (
    <StyledVideoList.Root css={{position: 'relative'}} ref={ref}>
      <StyledVideoList.Container css={{overflow: 'scroll'}}>
        {pagesWithTiles && pagesWithTiles.length > 0
          ? pagesWithTiles.map((tiles, pageNo) => (
              <Freeze freeze={useFreeze && page !== pageNo} key={pageNo}>
                <StyledVideoList.View
                  css={{
                    left: getLeft(pageNo, page),
                    transition: 'left 0.3s ease-in-out',
                    placeContent: 'initial',
                    justifyContent: 'center',
                    overflow: 'scroll',
                  }}>
                  {tiles.map((tile) =>
                    tile.track?.source === 'screen' ? (
                      <>
                        <ScreenshareTile
                          showStatsOnTiles={showStatsOnTiles}
                          key={tile.track.id}
                          width={tile.width}
                          height={tile.height}
                          peerId={tile.peer.id}
                        />
                      </>
                    ) : (
                      <>
                        <VideoTile
                          showStatsOnTiles={showStatsOnTiles}
                          key={tile?.track?.id || tile?.peer?.id}
                          width={tile.width}
                          height={tile.height}
                          peerId={tile.peer?.id}
                          trackId={tile.track?.id}
                        />
                      </>
                    )
                  )}
                </StyledVideoList.View>
              </Freeze>
            ))
          : null}
      </StyledVideoList.Container>
      {pagesWithTiles.length > 1 ? (
        <Pagination
          page={page}
          setPage={setPage}
          numPages={pagesWithTiles.length}
        />
      ) : null}
    </StyledVideoList.Root>
  );
};

const VideoList = React.memo(List);

const getOffset = ({appConfig, isHeadless}: any) => {
  const offset = appConfig?.headlessConfig?.tileOffset;
  if (!isHeadless || typeof offset !== 'number') {
    return 32;
  }
  return offset;
};

export default VideoList;
